import React, { useMemo } from "react";

const Footer = ({ timingColor, textColor, prayerData }) => {
  
  const { sunrise, zawal, jummahList } = useMemo(() => {
    if (!prayerData) return { sunrise: "—", zawal: "—", jummahList: [] };

    const timings = prayerData.startTimes?.timings || {};
    const list = Array.isArray(prayerData.jummahTimes) ? [...prayerData.jummahTimes] : [];
    
    // Sort Jummah by sequence
    list.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

    return {
      sunrise: timings.sunrise || "—",
      zawal: timings.dhuhr || "—", 
      jummahList: list
    };
  }, [prayerData]);

  const format = (t) => {
    if (!t || t === "—") return "—";
    return t.replace(/\s?(AM|PM)/i, "").replace(/^0/, "");
  };

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <div className="w-full flex justify-between items-center h-full px-4 text-center text-[20svh]">
      
      {/* Sunrise */}
      <div className="flex flex-col items-center">
        <div style={{ color: textColor }} className="text-[3svh] opacity-80">Sunrise</div>
        <div className="font-[Digital-7] text-[3svh] leading-none" style={{ color: timingColor }}>
          {format(sunrise)}
        </div>
        <div style={{ color: textColor }} className="text-[3svh]">اشراق</div>
      </div>

      {/* Zawal */}
      <div className="flex flex-col items-center">
        <div style={{ color: textColor }} className="text-[3svh] opacity-80">Zawal</div>
        <div className="font-[Digital-7] text-[3svh] leading-none" style={{ color: timingColor }}>
          {format(zawal)}
        </div>
        <div style={{ color: textColor }} className="text-[3svh]">زوال</div>
      </div>

      {/* Dynamic Jummahs */}
      {jummahList.map((jummah, index) => (
        <div key={index} className="flex flex-col items-center">
          <div style={{ color: textColor }} className="text-[3svh] opacity-80">
            {index === 0 ? "Jumu'ah" : `${getOrdinal(index + 1)} Jumu'ah`}
          </div>
          <div className="font-[Digital-7] text-[3svh] leading-none" style={{ color: timingColor }}>
            {format(jummah.iqama_Time || jummah.iqama_time)}
          </div>
          <div style={{ color: textColor }} className="text-[3svh]">
             {index === 0 ? "جمعہ" : index === 1 ? "جمعہ دوم" : "جمعہ سوم"}
          </div>
        </div>
      ))}

    </div>
  );
};

export default Footer;